import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ViewerRootComponent } from './viewer-root.component';

// Viewer routes are live-view only; snapshot route is defined at the app level.
const routes: Routes = [
  {
    path: '',
    component: ViewerRootComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'view/:siteId',
    component: ViewerRootComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'view/:siteId/:cameraId',
    component: ViewerRootComponent,
    canActivate: [MsalGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewerRoutingModule { }
